import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

@Injectable()
export class DataService_BusTrackerScanHistory {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	BusMapPreferenceSelect(PersonID) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusMapPreferenceSelect?PersonID=" + PersonID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanHistorySelectList(StartDate, EndDate, SchoolID, GradeLevelID, AcademyID, HomeroomID, GroupID, UserID) {
		var postResult$ = new Subject();
		var url =
			"BusTracker/ScanHistorySelectList?StartDate=" +
			StartDate +
			"&EndDate=" +
			EndDate +
			"&SchoolID=" +
			SchoolID +
			"&GradeLevelID=" +
			GradeLevelID +
			"&AcademyID=" +
			AcademyID +
			"&HomeroomID=" +
			HomeroomID +
			"&GroupID=" +
			GroupID +
			"&UserID=" +
			UserID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
